import { render, staticRenderFns } from "./AdminMenuItem.vue?vue&type=template&id=71c0e866"
import script from "./AdminMenuItem.vue?vue&type=script&lang=js"
export * from "./AdminMenuItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports